/**
 * Рубильник «временно разрешить правку старых карточек всем» (/api/ops/core-unlock).
 * Отдельно от repo.ts — это не справочник, а одна служебная настройка, видимая только
 * супер-админу (переключение) и всем (чтение, через AppSettings.core_unlock).
 */
import { authHeaders, notifyUnauthorized } from '@/auth/session';

const BASE = '/api';

export interface CoreUnlockState {
  enabled: boolean;
  since: number | null;
  by?: string | null;
}

async function req<T>(method: string, path: string, body?: unknown): Promise<T> {
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers: {
      Accept: 'application/json',
      ...(body !== undefined ? { 'Content-Type': 'application/json' } : {}),
      ...authHeaders(),
    },
    ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
  });
  if (res.status === 401) notifyUnauthorized();
  const json = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error((json as any)?.error || `HTTP ${res.status}`);
  return json as T;
}

export const getCoreUnlock = () => req<CoreUnlockState>('GET', '/ops/core-unlock');
export const setCoreUnlock = (enabled: boolean) =>
  req<CoreUnlockState>('PUT', '/ops/core-unlock', { enabled });
